import React, { useState } from 'react';
import { Row, Col, Accordion, Card, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import * as action from '../Store/SpecTemplate.action';
import * as masterAction from '../../../SystemMasters/Store/SystemMasters.action.js';
import { checkArray } from '../../../../Components/helper';
import Loader from '../../../../Components/Utility/Loader/Loader';
import PreviewModal from '../../../../Components/ModalPopup/PreviewModal';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import EditDocumentModal from './EditDocumentModal';
import AddSupportingDocuments from './AddSupportingDocuments';
import CustomToggle from '../../../../Components/CustomToggle';

function SupportingDocument({ specTemplateId, getSelectValue }) {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    showUploadModal: false,
    loader: false,
    showEditModal: false,
    editedData: null,
    showConfirmationPopup: false,
    deletedItems: [],
    showFilePreviewModal: false,
    selectedFileToPreview: null,
  });
  const { showUploadModal, loader, showEditModal, editedData, showConfirmationPopup, deletedItems, showFilePreviewModal, selectedFileToPreview } = state;
  const dispatch = useDispatch();
  const {
    SpecTemplateData: { specDocumentList },
    SystemMastersDetails: { documentTypeList },
  } = useSelector((reduxState) => reduxState);

  const getSpecDocument = async () => {
    setState((prevState) => ({
      ...prevState,
      loader: true,
    }));
    await dispatch(action.fetchSpecDocument(specTemplateId));
    await dispatch(masterAction.fetchDocumentType({}, t));
    setState((prevState) => ({
      ...prevState,
      loader: false,
    }));
  };

  const handleOpenDocument = () => {
    getSpecDocument();
  };

  const handleAddDocModal = () => {
    setState((prevState) => ({
      ...prevState,
      showUploadModal: true,
    }));
  };

  const handleCloseModal = () => {
    setState((prevState) => ({
      ...prevState,
      showUploadModal: false,
    }));
  };

  const ducumentUploaded = (value) => {
    if (value) {
      getSpecDocument();
      handleCloseModal();
    }
  };
  const handleEditDocument = (documentItem) => {
    setState((prevState) => ({
      ...prevState,
      showEditModal: true,
      editedData: documentItem,
    }));
  };

  const handleEditModal = (value) => {
    setState((prevState) => ({
      ...prevState,
      showEditModal: false,
      editedData: null,
    }));
    if (value) getSpecDocument();
  };
  const fetchFromS3 = (element) => {
    return element ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element}`) : '';
  };

  const handleDownload = async (element) => {
    fetch(fetchFromS3(element?.s3Key))
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', element?.fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => console.error('Error downloading file:', error));
  };

  const showCreatedandModified = (item) => {
    return (
      <button type="button" className="btn btn-action-icon " style={{ margin: '0' }}>
        <div className="info-container testing-action-spaceremoval">
          <span className="icon-info f-14" />
          <div className="info-content">
            {item?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('SPEC_TEMPLATE.COMPONENET.CREATED')}</strong> : {`${item?.createdBy?.firstName} ${item?.createdBy?.lastName} | `}
                {moment(item?.createdAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.modifiedBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('SPEC_TEMPLATE.COMPONENET.MODIFIED')}</strong> : {`${item?.modifiedBy?.firstName} ${item?.modifiedBy?.lastName} | `}
                {moment(item?.updatedAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const deleteDocument = (document) => {
    const objData = { _id: document?._id, key: document?.s3Key };
    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: true,
      deletedItems: [objData],
    }));
  };

  const handleDeleteModal = () => {
    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: false,
      deletedItems: [],
    }));
  };

  const handleConfirmDelete = async () => {
    const response = await dispatch(action.deleteDocuments(deletedItems, specTemplateId, t));
    if (response.code === 200) {
      getSpecDocument();
    }
    handleDeleteModal();
  };
  const isallChecked = checkArray(specDocumentList) && deletedItems.length === specDocumentList.length;

  const handleCheckAll = async (e) => {
    if (e.target.checked) {
      const allIds =
        specDocumentList &&
        checkArray(specDocumentList) &&
        specDocumentList.map((doc) => ({
          _id: doc._id,
          key: doc.s3Key,
        }));

      if (allIds) {
        setState((prevState) => ({
          ...prevState,
          deletedItems: allIds,
        }));
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        deletedItems: [],
      }));
    }
  };
  const handleCheckLibrary = async (isLibChecked, doument) => {
    const existingIds = deletedItems;
    if (isLibChecked && !existingIds?.some((existingEle) => existingEle?._id === doument?._id)) {
      setState((prevState) => ({
        ...prevState,
        deletedItems: [...existingIds, { _id: doument?._id, key: doument?.s3Key }],
      }));
    } else {
      const removedArray = existingIds?.filter((ele) => ele?._id !== doument?._id);

      if (checkArray(removedArray)) {
        setState((prevState) => ({
          ...prevState,
          deletedItems: removedArray,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          deletedItems: [],
        }));
      }
    }
  };

  const handleDeleteMultiple = () => {
    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: true,
    }));
  };

  const openFilePreview = (selectedDocument) => {
    setState((prev) => ({
      ...prev,
      selectedFileToPreview: selectedDocument,
      showFilePreviewModal: true,
    }));
  };

  const togglePreview = async () => {
    setState((prev) => ({
      ...prev,
      showFilePreviewModal: false,
      selectedFileToPreview: null,
    }));
  };

  return (
    <div className="collapse-card">
      <Accordion>
        <Card className="mb-3">
          <Card.Header>
            {t('SPEC_TEMP_LIBRARY.SUPPORTING_DOC_TITLE')}
            <Accordion.Toggle className="btn-toggle" onClick={() => handleOpenDocument()} as={Button} variant="link" eventKey="0">
              <CustomToggle eventKey="0" />
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Row>
                <Col md={12}>
                  <div className="d-flex mt-3 mb-3 align-items-center">
                    <h5 className="m-0">{t('SPEC_TEMP_LIBRARY.SUPPORTING_DOC_TITLE')}</h5>
                    <div className="side-icon order-lg-last">
                      <div className="d-flex supporting-doc-buttons mx-sm-3">
                        <button type="button" onClick={() => handleAddDocModal()} className="btn btn-outline">
                          <i className="icon-upload" />
                        </button>
                        {deletedItems?.length > 0 && (
                          <button type="button" onClick={() => handleDeleteMultiple()} className="btn btn-outline">
                            <i className="icon-delete" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {loader ? (
                    <Loader />
                  ) : (
                    <div className="p-0 mb-4 overRight-x">
                      <table className="table common-custom-table tr-white">
                        <thead className="light-grey text-center">
                          <tr className="">
                            <th className="w-50px text-center">
                              <div className="checkbox-label d-inline-block">
                                <input type="checkbox" onClick={(e) => handleCheckAll(e)} checked={isallChecked} id="check_all_doc" />
                                <label htmlFor="check_all_doc" className="chklabel">
                                  <span />
                                </label>
                              </div>
                            </th>

                            <th className="w-300px">{t('SPEC_TEMP_LIBRARY.COL_DOC_TITLE')}</th>
                            <th className="w-150px">{t('SPEC_TEMP_LIBRARY.COL_DOC_TYPE')}</th>
                            <th className="w-150px">{t('SPEC_TEMP_LIBRARY.COL_DOC_ACTION')}</th>
                          </tr>
                        </thead>

                        <tbody className="tabbody">
                          {specDocumentList?.map((document, i) => (
                            <tr key={document?._id}>
                              <td className="text-center">
                                <div className="checkbox-label d-inline-block">
                                  <input
                                    type="checkbox"
                                    onChange={(e) => handleCheckLibrary(e.target.checked, document)}
                                    checked={deletedItems?.some((doc) => doc._id === document?._id)}
                                    id={`check_doc_${i}`}
                                  />
                                  <label htmlFor={`check_doc_${i}`} className="chklabel">
                                    <span />
                                  </label>
                                </div>
                              </td>
                              <td>{document?.documentTitle}</td>
                              <td>
                                <span className="text-capitalize">{getSelectValue(documentTypeList, document?.documentType)?.name || '-'}</span>
                              </td>

                              <td>
                                <div className="d-flex align-items-center bom-doc-table-action">
                                  <button title={t('SPEC_TEMPLATE.COMPONENET.EDIT')} type="button" className="btn" onClick={() => handleEditDocument(document)}>
                                    <span className="icon-edit" />
                                  </button>
                                  {['wds', 'ruf', 'dxf'].includes(document.document) && (
                                    <button
                                      title={t('SPEC_TEMPLATE.COMPONENET.EDIT_PREVIEW')}
                                      type="button"
                                      onClick={() => openFilePreview(document)}
                                      className="btn"
                                    >
                                      <span className="icon-preview-template" />
                                    </button>
                                  )}
                                  <button
                                    className="btn"
                                    type="button"
                                    title={t('SPEC_TEMPLATE.COMPONENET.DOWNLOAD_FILE')}
                                    onClick={() => handleDownload(document)}
                                  >
                                    <i className="icon-download" />
                                  </button>
                                  <button title={t('SPEC_TEMPLATE.COMPONENET.DELETE')} type="button" className="btn" onClick={() => deleteDocument(document)}>
                                    <span className="icon-delete" />
                                  </button>
                                  {showCreatedandModified(document)}
                                </div>
                              </td>
                            </tr>
                          ))}

                          {isEmpty(specDocumentList) && (
                            <tr>
                              <td colSpan="4" className="text-center">
                                {t('SPEC_TEMPLATE.COMPONENET.NO_DOCUMENT_UPLOADED')}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {showUploadModal && (
                    <AddSupportingDocuments
                      specTemplateId={specTemplateId}
                      show={showUploadModal}
                      handleCloseModal={handleCloseModal}
                      ducumentUploaded={ducumentUploaded}
                      documentTypeList={documentTypeList}
                    />
                  )}

                  {showEditModal && <EditDocumentModal show={showEditModal} handlePopup={handleEditModal} data={editedData} specTemplateId={specTemplateId} />}
                  {showConfirmationPopup && (
                    <ConfirmationPopup
                      onOpen={showConfirmationPopup}
                      onConfirm={handleConfirmDelete}
                      // loading={loader}
                      title={t('SPEC_TEMP_LIBRARY.DELETE')}
                      message={t('SPEC_TEMP_LIBRARY.DELETE_MESSAGE')}
                      toggle={handleDeleteModal}
                    />
                  )}
                  {showFilePreviewModal && (
                    <PreviewModal onOpen={showFilePreviewModal} data={selectedFileToPreview} moduleName="specTemplate" toggle={togglePreview} />
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}

export default SupportingDocument;
